export default "__VITE_ASSET__f05420eb__"